<template>
  <div class="users-table-container">
    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando usuarios...</span>
      </div>
      <p class="mt-2 text-muted">Cargando usuarios...</p>
    </div>

    <div v-else-if="users.length === 0" class="text-center py-4">
      <i class="fas fa-users text-muted" style="font-size: 3rem;"></i>
      <p class="mt-2 text-muted">No se encontraron usuarios sin credenciales</p>
    </div>

    <v-data-table
      v-else
      :headers="headers"
      :items="users"
      :items-per-page="pagination.itemsPerPage"
      :server-items-length="pagination.totalItems"
      v-model="internalSelection"
      item-value="id"
      show-select
      class="elevation-1"
      hide-default-footer
      @input="handleSelectionChange"
    >
      <template v-slot:item.data-table-select="{ item, isSelected, select }">
        <input
          type="checkbox"
          class="form-check-input"
          :checked="isSelected"
          @change="select($event.target.checked)"
          :title="getSelectionTitle(item)"
        />
      </template>

      <template v-slot:item.created_at_convert_complete="{ item }">
        {{ formatDate(item.created_at_convert_complete) }}
      </template>

      <template v-slot:footer>
        <div class="text-center pt-3">
          <v-pagination 
            :value="pagination.page"
            :length="pagination.pageCount"
            :total-visible="6" 
            next-icon="fas fa-angle-right"
            prev-icon="fas fa-angle-left"
            @input="$emit('page-change', $event)"
          />
        </div>
      </template>
    </v-data-table>

    <div v-if="selectedUsers.length > 0" class="selection-summary mt-3">
      <div class="alert alert-info d-flex align-items-center">
        <i class="fas fa-info-circle me-2"></i>
        <span>
          {{ selectedUsers.length }} usuario{{ selectedUsers.length !== 1 ? 's' : '' }} seleccionado{{ selectedUsers.length !== 1 ? 's' : '' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsersDataTable',
  
  props: {
    users: { type: Array, default: () => [] },
    headers: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    pagination: { type: Object, required: true },
    selectedUsers: { type: Array, default: () => [] }
  },

  emits: ['update-selection', 'page-change'],

  data() {
    return {
      internalSelection: []
    }
  },

  watch: {
    selectedUsers: {
      handler(newVal) {
        this.internalSelection = [...newVal]
      },
      immediate: true
    }
  },

  methods: {
    handleSelectionChange(selection) {
      this.internalSelection = selection
      this.$emit('update-selection', selection)
    },

    getSelectionTitle(item) {
      return item.active ? 'Este usuario ya tiene credenciales' : 'Seleccionar usuario'
    },

    formatDate(date) {
      if (!date) return '-'
      try {
        return new Date(date).toLocaleDateString('es-ES')
      } catch {
        return date
      }
    }
  }
}
</script>

<style scoped>
.users-table-container {
  min-height: 300px;
}

.selection-summary {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}

.alert {
  border-radius: 0.5rem;
  margin-bottom: 0;
}
</style>